<script lang="ts">
    import {getLocalization} from 'src/core';
    import {Kind} from 'shared/constants';
    import type {Exemplar, ExemplarWithDocumentAndDiscardion, ViewableExemplar, ViewableExemplarWithDocument} from 'src/typings';
    import KpGenericPanel from 'shared/ui-widgets/panel/KpGenericPanel.svelte';
    import type {ComponentStyle} from 'shared/ui-widgets/types';
    import {exists} from 'shared/utils/custom-utils';
    import Label from 'shared/components/kp-label/Label.svelte';
    import {isExemplarWithDocumentAndDiscardion, isViewableExemplar, isViewableExemplarWithDocument} from './utils';

    type SupportedExemplarType = Exemplar | ExemplarWithDocumentAndDiscardion | ViewableExemplar | ViewableExemplarWithDocument;

    export let exemplar: SupportedExemplarType;
    export let isSelected: boolean;

    const localize = getLocalization();

    function isAvailable(ex: SupportedExemplarType): boolean {
        if (!isViewableExemplar(ex)) {
            return false;
        }
        return ex.availability.free;
    }

    function isNotAvailable(ex:  SupportedExemplarType): boolean {
        if (!isViewableExemplar(ex)) {
            return false;
        }
        const isLent = ex.availability.lent;
        const isError = ex.availability.error;
        const isFreeOrReservable = ex.availability.free || ex.availability.reservable;

        return isLent || (isError && !isFreeOrReservable);
    }

    function computePanelStyle(ex:  SupportedExemplarType): ComponentStyle {
        if (isAvailable(ex) || !isSelected) {
            return 'success';
        }
        if (isNotAvailable(ex) || !isSelected) {
            return 'danger';
        }
        if (isSelected) {
            return 'primary';
        }
        return 'default';
    }
</script>

<div class="selectable-exemplar-card">
    <KpGenericPanel panelStyle={computePanelStyle(exemplar)}>
        <svelte:fragment slot="heading">
            <span>{exemplar.designation}</span>
            {#if (isViewableExemplarWithDocument(exemplar)) || (isExemplarWithDocumentAndDiscardion(exemplar))}
                <span> - </span>
                {#if (isViewableExemplarWithDocument(exemplar))}
                    <span data-qa="exemplar-document-name">{exemplar.document?.name}</span>
                {/if}
                {#if (isExemplarWithDocumentAndDiscardion(exemplar))}
                    <span data-qa="exemplar-document-name">{exemplar.record.text}</span>
                {/if}
            {/if}
        </svelte:fragment>

        <div>{exemplar.loanCategory.text}</div>
        {#if isViewableExemplar(exemplar)}
            <div>
                {localize(/* @kp-localization commons.dostupnost */ 'commons.dostupnost')}:
                <strong class:text-success={isAvailable(exemplar)} class:text-danger={isNotAvailable(exemplar)}>
                    {exemplar.availability.text}
                </strong>
                {#if exists(exemplar.holder)}
                    <span> - </span>
                    <Label explicitKind={Kind.KIND_USER} labeled={exemplar.holder}/>
                {/if}
            </div>
        {/if}
    </KpGenericPanel>
</div>

<style lang="less">
    .selectable-exemplar-card {
        text-align: left;
        margin-bottom: 10px;
    }
</style>